import Button from "@material-ui/core/Button";
import Logo from "../Components/Layout/Logo";
import { VscSignOut } from "react-icons/vsc";
import { IoPeopleOutline } from "react-icons/io5";
import { MdWeb } from "react-icons/md";
import Typography from "@material-ui/core/Typography";
import Footer from "../Components/Layout/Footer";
import { Link } from "react-router-dom";
import {
  ThemeProvider as MuiThemeProvider,
  responsiveFontSizes,
} from "@material-ui/core/styles";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";

let theme = createMuiTheme();
theme = responsiveFontSizes(theme);

const Landing = () => {
  return (
    <MuiThemeProvider theme={theme}>
      <div className="root">
        <LeftCol />
        <RightCol />
      </div>
      <Footer />
    </MuiThemeProvider>
  );
};

const LeftCol = () => {
  return (
    <div className="left-col">
      <Tagline
        icon={<IoPeopleOutline />}
        label="Stay connected with students online."
      />
      <Tagline icon={<MdWeb />} label="Stay up to date on your Feed." />
      <Tagline icon="🚀" label="Share Educative posts." />
    </div>
  );
};

const Tagline = ({ icon, label }) => {
  return (
    <div className="tagline">
      <div className="icon">{icon}</div>
      <div className="label">{label}</div>
    </div>
  );
};

const RightCol = () => {
  return (
    <div className="right-col">
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-start",
          marginTop: "1rem",
        }}
      >
        <Logo />
      </div>
      <Typography
        variant="h2"
        style={{
          fontWeight: "bold",
          margin: "1rem",
          width: "100%",
          textAlign: "left",
        }}
      >
        Share your ideas,knowledge & experience.
      </Typography>
      <Typography
        variant="h4"
        style={{
          fontWeight: "bold",
          marginBottom: "1rem",
          width: "100%",
          textAlign: "left",
        }}
      >
        Join Studybud today.
      </Typography>
      <div className="btn-group">
        <Button
          variant="contained"
          color="primary"
          className="btn-primary"
          style={{ marginBottom: "1rem" }}
          component={Link}
          to="/signup"
        >
          Sign up
        </Button>
        <Button
          variant="outlined"
          color="primary"
          className="btn-outline"
          style={{ marginBottom: "1rem" }}
          component={Link}
          to="/login"
        >
          Log in
        </Button>
      </div>
    </div>
  );
};

export default Landing;

//Make it the main page when a user first lands in studybud then i'll style it and add content, it won't take me up to 2 days
